/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Toggle_ShowInputs */

const en_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Subtitle Styling`)
};

const fr_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le style des sous-titres`)
};

const de_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelformatierung anzeigen`)
};

const it_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra stile sottotitoli`)
};

const ru_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать стиль субтитров`)
};

const es_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar estilo de subtítulos`)
};

const zh_cn2_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示字幕样式`)
};

const ja_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕スタイルを表示`)
};

const hi_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक शैली दिखाएँ`)
};

const pt_pt2_image_export_style_toggle_show = /** @type {(inputs: Image_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir estilo de legenda`)
};

/**
* | output |
* | --- |
* | "Show Subtitle Styling" |
*
* @param {Image_Export_Style_Toggle_ShowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_toggle_show = /** @type {((inputs?: Image_Export_Style_Toggle_ShowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Toggle_ShowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_toggle_show(inputs)
	if (locale === "de") return de_image_export_style_toggle_show(inputs)
	if (locale === "it") return it_image_export_style_toggle_show(inputs)
	if (locale === "ru") return ru_image_export_style_toggle_show(inputs)
	if (locale === "es") return es_image_export_style_toggle_show(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_toggle_show(inputs)
	if (locale === "ja") return ja_image_export_style_toggle_show(inputs)
	if (locale === "hi") return hi_image_export_style_toggle_show(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_toggle_show(inputs)
	return en_image_export_style_toggle_show(inputs)
});